import { useState } from "react";
import { Plus, ListChecks, Activity, X } from "lucide-react";
import { useUI } from "@/context/UIContext";
import { useAuth } from "@/context/AuthContext";

export function QuickAddFab() {
  const { openTask, openQuickAction } = useUI();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const item = (Icon, label, onClick, testid) => (
    <button onClick={() => { setOpen(false); onClick(); }} data-testid={testid}
      className="flex items-center gap-2.5 rounded-full bg-white py-2 pl-3 pr-4 text-sm font-semibold text-slate-700 shadow-lg ring-1 ring-slate-200 active:scale-95">
      <Icon className="h-4 w-4 text-sky-600" />{label}
    </button>
  );
  return (
    <div className="fixed bottom-5 right-4 z-40 flex flex-col items-end gap-2 md:hidden" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="quick-add-fab">
      {open && (
        <>
          <div className="fixed inset-0 -z-10 bg-slate-900/20" onClick={() => setOpen(false)} />
          {item(ListChecks, "New Task", () => openTask({ prefill: { assigned_to_ids: user?.id ? [user.id] : [] } }), "quick-add-task")}
          {item(Activity, "Log Activity", () => openQuickAction({}), "quick-add-activity")}
        </>
      )}
      <button onClick={() => setOpen((o) => !o)} aria-label="Quick add" data-testid="quick-add-toggle"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-sky-600 text-white shadow-xl shadow-sky-600/30 transition-transform active:scale-95">
        {open ? <X className="h-6 w-6" /> : <Plus className="h-6 w-6" />}
      </button>
    </div>
  );
}
